<template>
  <CRow>
    <CCol sm='6' lg='3'>
      <CWidgetProgressIcon
        :header='students'
        text='عدد الطلاب'
        color='gradient-primary'
        inverse
        class="shadow cardborder .h4-color"
      >
        <CIcon name='cil-speedometer' height='36'/>
      </CWidgetProgressIcon>
          </CCol>
                <CCol sm='6' lg='3'>
      <CWidgetProgressIcon
        :header='courses'
        text='الدورات'
        color='gradient-warning'
        class="shadow cardborder"
        inverse
      >
        <CIcon name='cil-basket' height='36'/>
      </CWidgetProgressIcon>
                </CCol>
                      <CCol sm='6' lg='3'>
      <CWidgetProgressIcon
        :header='studentsCourses'
        text='الطلاب المسجلين في الدورات '
        color='gradient-info'
        inverse
        class="shadow cardborder"
      >
        <CIcon name='cil-chartPie' height='36'/>
      </CWidgetProgressIcon>
                      </CCol>
                            <CCol sm='6' lg='3'>

      <CWidgetProgressIcon
        :header='categories'
        text='عدد الأقسام'
        color='gradient-success'
        inverse
        class="shadow cardborder"
      >
        <CIcon name='cil-speedometer' height='36'/>
      </CWidgetProgressIcon>
                            </CCol>
                            </CROW>
</template>

<script>

export default {
  name: 'Widgets',
  data () {
    return {
      courses: '0',
      students: '0',
      categories: '0',
      studentsCourses: '0'
    }
  },
  created () {
    this.$http
      .get(`${this.$hostUrl}statistics`)
      .then((response) => {
        this.courses = response.data.data.courses.toString()
        this.students = response.data.data.students.toString()
        this.categories = response.data.data.categories.toString()
        this.studentsCourses = response.data.data.students_courses.toString()
      })
  }
}
</script>
